
function menu(state={
  // OTHER
  isPremium: false,
  hasTrial: false,
  isEnterpriseOwner: false,
  isAccountant: false,
  hasApp: false,
  // Navigation
  // TODO move elsewhere
  isOpen:false,
  isMoreOpen: false,
}, action) {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      // if (state.hasFormChanged) {
      //    alert("do you want to save?")
      // }
      return {
        ...state,
        isMoreOpen: false,
        isOpen: false
      }

    case 'TOGGLE_MORE_NAV':
      return {
        ...state,
        isMoreOpen: !state.isMoreOpen,
        isOpen: false,
      }

    case 'TOGGLE_NAV':
      return {
        ...state,
        isOpen: !state.isOpen,
        isMoreOpen: false
      }

    default:
      return state
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/account/menu/reducer.js